var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5496 0.545434C18.0391 0.541074 16.5897 1.14125 15.5244 2.21196L1.21629 16.5201L0.82404 16.914C0.450777 17.2888 0.241211 17.7962 0.241211 18.3252V24.5454C0.241211 25.0977 0.688926 25.5454 1.24121 25.5454H7.45896C7.98939 25.5454 8.4981 25.3347 8.87317 24.9596L23.5747 10.2581C24.6401 9.19057 25.2386 7.74346 25.2378 6.23505C25.2372 4.72633 24.6379 3.27975 23.5712 2.21308C22.5046 1.1464 21.0581 0.546327 19.5496 0.545434ZM6.90814 22.2122H3.57471V18.8788L14.0621 8.39138L17.3955 11.7248L6.90814 22.2122ZM21.2162 7.9041L19.7537 9.36661L16.4203 6.03319L17.8828 4.57068C18.3194 4.1039 18.9268 3.83448 19.5659 3.82401C20.2051 3.81326 20.8209 4.06234 21.2729 4.51429C21.7248 4.96625 21.9739 5.58216 21.9631 6.22122C21.9527 6.86035 21.683 7.46757 21.2162 7.9041Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon_edit.a5a21e070d923d9d49686458b8df1e8d.svg";
export { ForwardRef as ReactComponent };